import React, { useEffect, useState } from "react";
import cross_img from "../../assets/img/cross_img.svg";
import edit2 from "../../assets/img/edit-2.svg";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Header from "../Header/Header";
import { getEmployeeList, addEmployee, editEmployee, deleteEmployee } from "../../redux/employeeSlice";
import { useNavigate } from "react-router-dom";
import { VisibilityOffTwoTone, VisibilityTwoTone } from "@mui/icons-material";
import ai_img from "../../assets/img/img-logo.svg";
import { format } from 'date-fns';


const Employee = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [profileData, setProfileData] = useState({});
    const [employeeList, setEmployeeList] = useState([]);
    const [rowId, setRowId] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editData, setEditData] = useState({ firstName: "", lastName: "", email: "", _id: "", password: "" });

    const [showAddModal, setShowAddModal] = useState(false);
    const [newEmployee, setNewEmployee] = useState({ firstName: "", lastName: "", email: "", password: "", confirmPassword: "" });
    const [formError, setFormError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const profileResponse = useSelector((state) => state.getProfileReducer.data);
    useEffect(() => {
        if (profileResponse != null && profileResponse.status == 1) {
            setProfileData(profileResponse.data);
        }
    }, [profileResponse]);
    const employeeListResponse = useSelector(
        (state) => state.employee.employees
    );

    useEffect(() => {
        dispatch(getEmployeeList());
    }, [dispatch]);

    useEffect(() => {
        if (employeeListResponse) {
            setEmployeeList(employeeListResponse);
        }
    }, [employeeListResponse]);

    const handleOpenModal = (id) => {
        setRowId(id);
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setFormError("")
        setShowModal(false);
    };

    const handleDelete = (id) => {
        dispatch(deleteEmployee(id))
            .then((res) => {
                if (res.error) {
                    setFormError(res.payload || "Something went wrong");
                    return;
                }
                setNewEmployee({ firstName: "", lastName: "", email: "", password: "" });
                setShowModal(false);
            });
    };

    const handleEditModalOpen = (row) => {
        setEditData({
            firstName: row.firstName || "",
            lastName: row.lastName || "",
            email: row.email,
            _id: row._id,
            password: row.password || ""
        });
        setShowEditModal(true);
    };

    const handleEditModalClose = () => {
        setFormError("")
        setShowEditModal(false);
    };

    const handleInputChange = (e) => {
        setFormError("");
        const { name, value } = e.target;
        setEditData({ ...editData, [name]: value });
    };

    const handleUpdate = () => {
        const { firstName, lastName, email, password } = editData;
        if (!firstName || !lastName || !email || !password) {
            setFormError("Please fill all fields");
            return;
        }
        setFormError("")
        dispatch(editEmployee({ ...editData, employeeId: editData._id }))
            .then((res) => {
                if (res.error) {
                    setFormError(res.payload || "Something went wrong");
                    return;
                }
                setFormError("");
                setEditData({ firstName: "", lastName: "", email: "", password: "", _id: "" });
                setShowEditModal(false);
            });
    };

    const handleAdd = () => {
        const { firstName, lastName, email, password, confirmPassword } = newEmployee;
        if (!firstName || !lastName || !email || !password || !confirmPassword) {
            alert("All fields are required");
            return;
        }
        if (password !== confirmPassword) {
            alert("Password and confirm password must be equal")
        }

        setFormError("");

        dispatch(addEmployee(newEmployee))
            .then((res) => {
                if (res.error) {
                    setFormError(res.payload || "Something went wrong");
                    return;
                }
                setFormError("");
                setNewEmployee({ firstName: "", lastName: "", email: "", password: "" });
                setShowAddModal(false);
            });
    };

    return (
        <div className="sidebar_mar">
            <Header />
            <div className="project_btn_style">
                <h2>Users</h2>
                {employeeList.length !== 0 && <Button type="button" onClick={() => {
                    if (profileData.isSubscribed === 0) {
                        alert('Please subscribe to add employee')
                        navigate('/subscription-plans')
                    } else {
                        setShowAddModal(true)
                    }
                }}>
                    Add New
                </Button>}
            </div>
            {employeeList.length !== 0 ? (
                <div className="table_style">
                    <table className="data-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Created At</th>
                                <th colSpan="2" className="text_center">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {employeeList.map((row, index) => (
                                <tr key={index}>
                                    <td style={{ color: "#0F0F0F", fontSize: '12px', fontWeight: 500 }}>
                                        {row.firstName} {row.lastName}
                                    </td>
                                    <td style={{ color: "#0F0F0F", fontSize: '12px', fontWeight: 500 }}>
                                        {row.email}
                                    </td>
                                    <td style={{ color: "#636363", fontSize: '12px', fontWeight: 500 }}>{format(new Date(row.createdAt), 'dd.MM.yyyy')}</td>
                                    <td className="text_center">
                                        <img
                                            src={edit2}
                                            alt="delete"
                                            style={{ cursor: "pointer", width: "13px", marginRight: "15px" }}
                                            onClick={() => handleEditModalOpen(row)}
                                        />
                                        <img
                                            src={cross_img}
                                            alt="delete"
                                            style={{ cursor: "pointer", width: "17px" }}
                                            onClick={() => handleOpenModal(row._id)}
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>) : (<div className="no-project-container">
                    <h3>No team members to display yet.</h3>
                    <p>Use the button below to add one.</p>
                    <Button type="button" onClick={() => {
                        if (profileData.isSubscribed === 0) {
                            alert('Please subscribe to add employee')
                            navigate('/subscription-plans')
                        } else {
                            setShowAddModal(true)
                        }
                    }}>
                        Add New
                    </Button>
                </div>)}

            {/* Delete Modal */}
            {showModal && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "#35364133",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000,
                }}>
                    <div style={{
                        background: "#fff",
                        borderRadius: "24px",
                        padding: "15px",
                        width: "90%",
                        maxWidth: "450px",
                        boxShadow: "0px 0px 20px #00000017",
                        overflow: "hidden",
                    }}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                paddingBottom: "15px",
                                justifyContent: "center",
                                flexDirection: "column",
                            }}
                        >
                            <h3 style={{
                                marginBottom: "1rem",
                                fontSize: "28px",
                                color: "#0F0F0F",
                                fontWeight: "700",
                            }}>
                                Delete User
                            </h3>
                            {formError && <p className="text-danger">{formError}</p>}
                            <p style={{ fontSize: "15px", fontWeight: 500, color: "#0F0F0F", marginBottom: "1rem" }}>Do you really want to delete?</p>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "12px",
                                    marginTop: "10px",
                                }}
                            >

                                <Button
                                    style={{
                                        border: "1px solid #0F0F0F",
                                        fontFamily: "inherit",
                                        padding: "12px 24px",
                                        fontSize: "15px",
                                        fontWeight: 700,
                                        cursor: "pointer",
                                        color: "#0F0F0F",
                                        borderRadius: "8px",
                                        backgroundColor: "#FFFFFF",
                                        width: "100%"
                                    }}
                                    onClick={handleCloseModal}
                                >Cancel</Button>
                                <Button
                                    style={{
                                        fontFamily: "inherit",
                                        padding: "12px 24px",
                                        fontSize: "15px",
                                        fontWeight: 700,
                                        cursor: "pointer",
                                        color: "#FFFFFF",
                                        backgroundColor: "#0F0F0F",
                                        borderRadius: "8px",
                                        width: "100%"
                                    }}
                                    onClick={() => handleDelete(rowId)}
                                >Confirm</Button>
                            </div>
                        </div>

                    </div>
                </div>
            )}
            {/* Edit Modal */}
            {showEditModal && (
                <div style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    backgroundColor: "#35364133",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000,
                }}>
                    <div style={{
                        background: "#fff",
                        borderRadius: "24px",
                        padding: "24px",
                        width: "90%",
                        maxWidth: "450px",
                        boxShadow: "0px 0px 20px #00000017",
                        overflow: "hidden",
                    }}>
                        {/* HEADER */}
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginBottom: "20px",
                            paddingBottom: "15px",
                            justifyContent: "center",
                            flexDirection: "column",
                        }}>
                            <h3
                                style={{
                                    margin: 0,
                                    fontSize: "28px",
                                    color: "#0F0F0F",
                                    fontWeight: "700",
                                }}
                            >
                                Edit User
                            </h3>
                        </div>

                        {/* BODY */}
                        {formError && <p className="text-danger">{formError}</p>}
                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                            {/* Inputs */}

                            <div style={{ display: "flex", gap: "16px" }}>
                                <div>
                                    <label style={{ fontSize: "15px", fontWeight: 500, color: "#0F0F0F" }}>First name</label>
                                    <input type="text" name="firstName" value={editData.firstName} onChange={handleInputChange} style={inputStyle} />
                                </div>
                                <div>
                                    <label style={{ fontSize: "15px", fontWeight: 500, color: "#0F0F0F" }}>Last name</label>
                                    <input type="text" name="lastName" value={editData.lastName} onChange={handleInputChange} style={inputStyle} />
                                </div>
                            </div>


                            <div>
                                <label style={{ fontSize: "15px", fontWeight: 500, color: "#0F0F0F" }}>Email address</label>
                                <input type="email" name="email" value={editData.email} onChange={handleInputChange} style={inputStyle} />
                            </div>
                            <div style={{ position: "relative" }}>
                                <label style={{ fontSize: "15px", fontWeight: 500, color: "#0F0F0F" }}>Password</label>
                                <input type={showPassword ? "text" : "password"} name="password" value={editData.password || ""} onChange={handleInputChange} style={inputStyle} />
                                <button
                                    type="button"
                                    className="passwod_btn"
                                    onClick={() => {
                                        setShowPassword(!showPassword);
                                    }}
                                    style={{
                                        position: "absolute",
                                        right: "15px",
                                        background: "transparent",
                                        padding: 0,
                                        bottom: "3px",
                                    }}
                                >
                                    {showPassword ? (
                                        <VisibilityTwoTone />
                                    ) : (
                                        <VisibilityOffTwoTone />
                                    )}
                                </button>
                            </div>

                            {/* FOOTER */}
                            <div
                                className="cancel_create_btn"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "12px",
                                    marginTop: "10px",
                                }}
                            >
                                <Button
                                    variant="secondary"
                                    onClick={handleEditModalClose}
                                    style={{
                                        border: "1px solid #0F0F0F",
                                        fontFamily: "inherit",
                                        padding: "12px 24px",
                                        fontSize: "15px",
                                        fontWeight: 700,
                                        cursor: "pointer",
                                        color: "#0F0F0F",
                                        borderRadius: "8px",
                                        backgroundColor: "#FFFFFF",
                                        width: "100%"
                                    }}
                                >Cancel</Button>
                                <Button
                                    variant="primary"
                                    onClick={handleUpdate}
                                    style={{
                                        fontFamily: "inherit",
                                        padding: "12px 24px",
                                        fontSize: "15px",
                                        fontWeight: 700,
                                        cursor: "pointer",
                                        color: "#FFFFFF",
                                        backgroundColor: "#0F0F0F",
                                        borderRadius: "8px",
                                        width: "100%"
                                    }}
                                >Update</Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {/* Add Modal */}
            {showAddModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "#35364133",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: "24px",
                            padding: "24px",
                            width: "90%",
                            maxWidth: "450px",
                            boxShadow: "0px 0px 20px #00000017",
                            overflow: "hidden",
                        }}
                    >
                        {/* HEADER START */}
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                marginBottom: "20px",
                                paddingBottom: "15px",
                                justifyContent: "center",
                                flexDirection: "column",
                            }}
                        >

                            <h3
                                style={{
                                    margin: 0,
                                    fontSize: "28px",
                                    color: "#0F0F0F",
                                    fontWeight: "700",
                                }}
                            >
                                Add User
                            </h3>
                        </div>

                        {formError && <p className="text-danger">{formError}</p>}

                        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>

                            <div style={{ display: "flex", gap: "16px" }}>
                                <div>
                                    <label style={{ fontSize: "15px", fontWeight: 500, color: "#0F0F0F" }}>First name</label>
                                    <input

                                        type="text"
                                        name="firstName"
                                        value={newEmployee.firstName}
                                        onChange={(e) =>
                                            setNewEmployee({ ...newEmployee, firstName: e.target.value })
                                        }
                                        style={inputStyle}
                                    />
                                </div>
                                <div>
                                    <label style={{ fontSize: "15px", fontWeight: 500, color: "#0F0F0F" }}>Last name</label>
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={newEmployee.lastName}
                                        onChange={(e) =>
                                            setNewEmployee({ ...newEmployee, lastName: e.target.value })
                                        }
                                        style={inputStyle}
                                    />
                                </div>
                            </div>

                            <div>
                                <label style={{ fontSize: "15px", fontWeight: 500, color: "#0F0F0F" }}>Email address</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={newEmployee.email}
                                    onChange={(e) =>
                                        setNewEmployee({ ...newEmployee, email: e.target.value })
                                    }
                                    style={inputStyle}
                                />
                            </div>
                            <div style={{ position: "relative" }}>
                                <label style={{ fontSize: "15px", fontWeight: 500, color: "#0F0F0F" }}>Password</label>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    value={newEmployee.password}
                                    onChange={(e) =>
                                        setNewEmployee({ ...newEmployee, password: e.target.value })
                                    }
                                    style={inputStyle}
                                />
                                <button
                                    type="button"
                                    className="password_btn"
                                    onClick={() => {
                                        setShowPassword(!showPassword);
                                    }}
                                    style={{
                                        position: "absolute",
                                        right: "15px",
                                        background: "transparent",
                                        padding: 0,
                                        bottom: "3px",
                                    }}
                                >
                                    {showPassword ? <VisibilityTwoTone /> : <VisibilityOffTwoTone />}
                                </button>
                            </div>

                            <div style={{ position: "relative" }}>
                                <label style={{ fontSize: "15px", fontWeight: 500, color: "#0F0F0F" }}>Confirm password</label>
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    name="confirmPassword"
                                    value={newEmployee.confirmPassword}
                                    onChange={(e) =>
                                        setNewEmployee({ ...newEmployee, confirmPassword: e.target.value })
                                    }
                                    style={inputStyle}
                                />
                                <button
                                    type="button"
                                    className="password_btn"
                                    onClick={() => {
                                        setShowConfirmPassword(!showConfirmPassword);
                                    }}
                                    style={{
                                        position: "absolute",
                                        right: "15px",
                                        background: "transparent",
                                        padding: 0,
                                        bottom: "3px",
                                    }}
                                >
                                    {showConfirmPassword ? <VisibilityTwoTone /> : <VisibilityOffTwoTone />}
                                </button>
                            </div>
                            <div
                                className="cancel_create_btn"
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "12px",
                                    marginTop: "10px",
                                }}
                            >
                                <Button
                                    // className="cancel_btn"
                                    variant="secondary"
                                    style={{
                                        border: "1px solid #0F0F0F",
                                        fontFamily: "inherit",
                                        padding: "12px 24px",
                                        fontSize: "15px",
                                        fontWeight: 700,
                                        cursor: "pointer",
                                        color: "#0F0F0F",
                                        borderRadius: "8px",
                                        backgroundColor: "#FFFFFF",
                                        width: "100%"
                                    }}
                                    onClick={() => {
                                        setFormError("");
                                        setShowAddModal(false);
                                    }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    style={{
                                        fontFamily: "inherit",
                                        padding: "12px 24px",
                                        fontSize: "15px",
                                        fontWeight: 700,
                                        cursor: "pointer",
                                        color: "#FFFFFF",
                                        backgroundColor: "#0F0F0F",
                                        borderRadius: "8px",
                                        width: "100%"
                                    }}
                                    // className="create_btn"
                                    variant="primary"
                                    onClick={handleAdd}
                                >
                                    Add
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
};

const inputStyle = {
    width: "100%",
    padding: "12px",
    border: "1px solid #DBDBDB",
    borderRadius: "8px",
    marginTop: "5px",
    color: "#0F0F0F",
    fontWeight: 500,
    fontSize: "15px"
};

export default Employee;
